/* global window */

import { debounce, isString } from 'lodash-es';
import axios from 'axios';

export default function debounceFetcher({
  fetchRef,
  setOptions,
  setFetching,
  requestPath,
  minInputSize = 3,
  responseFormat = ({ data }) => data,
  itemsToExcludeKeys = [],
}) {
  const setFilteredOptions = (options) => {
    if (itemsToExcludeKeys.length > 0) {
      const filteredOptions = options.filter((option) => !itemsToExcludeKeys.includes(option.key));
      setOptions(filteredOptions);
    } else {
      setOptions(options);
    }
  };

  const resolvePath = (search) => {
    if (isString(requestPath)) {
      const url = new URL(globalThis.location.origin + requestPath);
      url.searchParams.append('search', search);

      return url;
    }

    return requestPath({ search, format: 'json' });
  };

  const loadOptions = (search) => {
    if (search.length < minInputSize) {
      return;
    }

    fetchRef.current += 1;

    const fetchId = fetchRef.current;

    setOptions([]);
    setFetching(true);

    axios({
      url: resolvePath(search),
      method: 'GET',
      responseType: 'json',
    }).then((response) => {
      if (fetchId !== fetchRef.current) return;

      setFilteredOptions(responseFormat(response));
      setFetching(false);
    });
  };

  return debounce(loadOptions, 500);
}
